import r from "../managers/braze-instance.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import ee, { STORAGE_KEYS as s } from "../managers/storage-manager.js";
export function enableSDK() {
  new ee.ne(null, !0).remove(s.ie);
  var e = et.Us.Rs;
  new et(e, E).be(e.Fs.le, e.me), E.info("enableSDK was called"), r.destroy(!1), r.ce(!1);
}